import React from 'react';

const  Page403 = () => {

    return (
        <div className="not-found">
            <h1 className="">Page 403 | Forbedden</h1>
            <h3 className="">Access Denied .! As you are not an Admin </h3>
        </div>
       
    )
}
export default Page403;